import { isFolderLike, type FileSystemItem } from '@/components/document/sub-components/file-manager/types';

export const sortFileSystemItems = (
  items: FileSystemItem[],
): FileSystemItem[] =>
  [...items].sort((a, b) => {
    // Folder-shaped rows (directories AND mounts) group before files — isFolderLike, not
    // `type === 'directory'`, so a mount groups correctly even though its `type` differs.
    if (isFolderLike(a) !== isFolderLike(b)) return isFolderLike(a) ? -1 : 1;
    return a.name.localeCompare(b.name);
  });
